export default __webpack_public_path__ + "static/media/popular-place-bail.89337c78.jpg";